export const manifestLocales = {
  audio: {
    previewImageAlt: {
      en: 'audio widget',
      he: 'אודיו'
    }
  }
};
